import React, { useState, useEffect } from "react";

const MultiInputTag = ({ onItemsChange, limit }) => {
  const [inputValue, setInputValue] = useState("");
  const [items, setItems] = useState([]);

  const handleInputChange = (value) => {
    if (!value || value === "") return;
    const splitAndTrimmedValue = value.split(/,+/).filter(Boolean);
    const newItems = items.concat(splitAndTrimmedValue).slice(0, limit);
    setItems(newItems);
    setInputValue("");
  };

  const isValidPhoneNumber = (phoneNumber) => {
    // check if the phone number contains only digits
    const regex = /^(\+?\d+)$/;
    return regex.test(phoneNumber.trim());
  };

  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  useEffect(() => {
    onItemsChange(items);
  }, [items, onItemsChange]);

  return (
    <div>
      <div className="block w-full p-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
        {items.length > 0 && (
          <div
            className="p-2 text-right text-xs leading-4 font-medium text-indigo-500 cursor-pointer"
            onClick={() => setItems([])}
          >
            Clear All
          </div>
        )}
        <div className="p-1">
          {items.map((item, index) => (
            <span
              key={item}
              className={`inline-flex items-center justify-between ${
                isValidPhoneNumber(item) ? "bg-indigo-300" : "bg-red-300"
              } px-3 py-1 text-sm font-semibold text-gray-700 m-1 rounded-md`}
            >
              <span>{item}</span>
              <button
                onClick={() => removeItem(index)}
                className="ml-3 text-gray-500 hover:text-gray-800 focus:outline-none text-xs"
              >
                ✕
              </button>
            </span>
          ))}
        </div>
        <input
          type="text"
          placeholder="Add the items here, then press Enter."
          value={inputValue}
          disabled={items.length >= limit}
          className="py-2 px-3 block w-full p-0 border-0 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 mt-3 sm:leading-5"
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") handleInputChange(e.target.value);
          }}
        />
      </div>
      {items.length >= limit && (
        <div className="text-xs text-red-500 mt-1">
          You have reached the limit of {limit}
        </div>
      )}
    </div>
  );
};

export default MultiInputTag;
